<template>
  <router-view />
</template>

<script>
</script>


<style lang="scss">
// @import './App.scss';
.p-breadcrumb {
  margin-bottom: 20px;
  background-color: var(--blue-900);
  color: white !important;
}
</style>
